<div class="route-threads" *ngIf="threads?.length">
  <p-accordion>
    <p-accordionTab [header]="'Schedule History (' + threads.length + ')'">
      <div class="thread-list">
        <div
          *ngFor="let thread of threads; trackBy: trackByThreadId"
          class="thread-item"
        >
          <div class="thread-main">
            <i class="pi pi-send thread-icon"></i>
            <div class="thread-info">
              <span class="thread-date">{{ thread.createdAt | date: 'MMM d, h:mm a' }}</span>
              <span class="thread-summary">{{ getRecipientsLabel(thread) }}</span>
            </div>
            <p-tag
              *ngIf="thread.replyIds?.length"
              [value]="thread.replyIds.length + ' repl' + (thread.replyIds.length === 1 ? 'y' : 'ies')"
              severity="secondary"
              styleClass="replies-tag"
            />
          </div>
        </div>
      </div>
    </p-accordionTab>
  </p-accordion>
</div>
